module.exports = __webpack_public_path__ + "static/img/bg_benefit_money_30_.69322a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_benefit_money_30_.png
// module id = Ftfp
// module chunks = 0